import { isSameEmail } from '@griply/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  ChangeEmailFormFields,
  validationSchema,
} from 'shared/types/change-email-form';

const SAME_EMAIL_ERROR = 'same-email';

// The account's own address is refused here, so it never costs a reauthentication or a request.
export const useChangeEmailForm = (
  currentEmail: string,
  submit: (newEmail: string, password: string) => void,
) => {
  const { handleSubmit, ...formProps } = useForm<ChangeEmailFormFields>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const onSubmit = handleSubmit(({ newEmail, password }) => {
    if (isSameEmail(newEmail, currentEmail)) {
      formProps.setError('newEmail', { type: SAME_EMAIL_ERROR });
      return;
    }
    submit(newEmail.trim(), password);
  });

  const { errors } = formProps.formState;

  return {
    ...formProps,
    onSubmit,
    errors,
    isSameEmail: errors.newEmail?.type === SAME_EMAIL_ERROR,
  };
};
